import { Injectable } from '@angular/core';
import { SCConfig } from '../constant/sc-config.constant';
import { UserInfoService } from '../../shared/standalone-packages/ecap3/core';

@Injectable()
export class SecurityPermissionService {
    constructor(private userInfoService: UserInfoService) {}

    getUserRole(loggedInUserRoles?) {
        const userRoles = loggedInUserRoles || this.userInfoService.userInfo.Roles;
        if (userRoles && userRoles.length) {
            if (userRoles.indexOf(SCConfig.Roles.Admin) > -1) {
                return SCConfig.Roles.Admin;
            }
        }
        return '';
    }
}
